import React from 'react';

import { Screen, withScreen, createScreenRoute } from '@gogame/screens';
import { Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';

import { CountryGroupDetailsRouteElement } from './components/CountryGroupDetails';
import CountryGroupsDataTable from './components/CountryGroupsDataTable';
import {
  countryGroupsSearchParams,
  countryGroupsLink,
  countryGroupsDetailsLink,
} from './navigation';
import screenReducer from './screenReducer';

const id = 1045;
const permission = 66;

const CountryGroups = withScreen({
  name: 'country-groups',
  searchParams: countryGroupsSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <CountryGroupsDataTable />
        <Sentry.Routes>
          <Route
            path={countryGroupsDetailsLink.path}
            element={<CountryGroupDetailsRouteElement />}
          />
        </Sentry.Routes>
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Country Groups',
  link: countryGroupsLink,
  screen: <CountryGroups />,
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/360035730673-Country-Groups',
});
